import { render, staticRenderFns } from "./vliveTrailer.vue?vue&type=template&id=08b7f03e&"
import script from "./vliveTrailer.vue?vue&type=script&lang=js&"
export * from "./vliveTrailer.vue?vue&type=script&lang=js&"
import style0 from "./vliveTrailer.vue?vue&type=style&index=0&lang=scss&rel=stylesheet%2Fscss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports